import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'camelCase'
})
export class CamelCasePipe implements PipeTransform {
  transform(input: string, ignoreInsideParentheses: boolean = false): string {
    if (!ignoreInsideParentheses) {
      return input.split(' ').map(word =>{
        if(word.charAt(0) !== '('){
          return word.charAt(0) + word.slice(1).toLowerCase();
        }
        else{
          return word;
        }
      }).join(' ');
    }
    else {
      return input.split(' ').map(word => word.charAt(0) + word.slice(1).toLowerCase()).join('-');
    }
  }
}